import {
  Button,
  FormField,
  Grid,
  Multiselect,
} from '@amzn/awsui-components-react';
import React, { useCallback, useState } from 'react';
import { ExternalDashboard } from '../../../Domain/Cloudwatch/ExternalDashboard';
import {
  ExternalWidget,
  SelectProps,
} from '../../../Domain/Cloudwatch/model';
import { CommonDomainProps } from '../../../models/types';
import { getDomainIdentifier } from '../../../utils/helpers';
import './../../../Styles/cloudwatch-dasboard.css';
import { ILE_DIRECT_MEMORY_METRICS_OPTIONS } from './constants';
import { getIleDirectMemoryMetrics } from './utils';

interface IleDirectMemoryMetricsForm {
  selectedMetrics: SelectProps.Options;
  isDirty: boolean;
}

interface IleDirectMemoryMetricsProps extends CommonDomainProps {
  clientId: string;
  domainName: string;
  cellId: string;
  metricRange: any;
  region: string;
  initialValues?: IleDirectMemoryMetricsForm;
  utcOffset: number;
}

const IleDirectMemoryMetrics = (props: IleDirectMemoryMetricsProps) => {
  const initialValues = props.initialValues || {
    selectedMetrics: [],
    isDirty: false,
  };
  const [formValues, setFormValues] = useState<IleDirectMemoryMetricsForm>(initialValues);
  const [externalWidgets, setExternalWidgets] = useState<ExternalWidget[]>([]);

  const isFormInvalid = () => formValues.selectedMetrics.length === 0;

  const handleSubmit = useCallback(() => {
    const selectedMetrics = formValues.selectedMetrics
      ? formValues.selectedMetrics.map((metric) => metric.value)
      : [];
    // cellId resolves the internal rate gauges (isRootAccount) to the service/root account;
    // the customer metrics resolve to clientId inside the widget builder.
    const widgets = getIleDirectMemoryMetrics(
      props.domainName,
      props.clientId,
      props.cellId,
      props.region,
      selectedMetrics,
      false
    ) as ExternalWidget[];
    setExternalWidgets(widgets);
  }, [formValues, props]);

  return (
    <React.Fragment>
      <Grid
        className="dasboard-explorer"
        gridDefinition={[
          { colspan: 3 },
          { colspan: 3 },
        ]}
      >
        <FormField description="Choose metric type from the list." label="Metric">
          <Multiselect
            selectedOptions={formValues.selectedMetrics}
            deselectAriaLabel={(e) => 'Remove ' + e.label}
            options={ILE_DIRECT_MEMORY_METRICS_OPTIONS}
            placeholder="Choose options"
            selectedAriaLabel="Selected"
            filteringType="auto"
            onChange={({ detail }) =>
              setFormValues((prevFormValues: IleDirectMemoryMetricsForm) => ({
                ...prevFormValues,
                selectedMetrics: detail.selectedOptions,
                isDirty: true,
              }))
            }
          />
        </FormField>
        <Button
          className="explorer-button-checkbox"
          variant="primary"
          disabled={isFormInvalid()}
          onClick={handleSubmit}
        >
          Fetch
        </Button>
      </Grid>
      {externalWidgets && externalWidgets.length > 0 ? (
        <ExternalDashboard
          utcOffset={props.utcOffset}
          widgets={externalWidgets}
          domainIdentifier={getDomainIdentifier(props.clientId, props.domainName)}
          metricRange={props.metricRange}
        />
      ) : null}
    </React.Fragment>
  );
};

export { IleDirectMemoryMetrics };
